import { create } from 'zustand';

export type ThemeMode = 'default' | 'simple' | 'highContrast';

const STORAGE_KEY = 'frostgrave:ui:theme';
const LEGACY_HIGH_CONTRAST_KEY = 'frostgrave:ui:high-contrast';

const isThemeMode = (value: string | null): value is ThemeMode =>
  value === 'default' || value === 'simple' || value === 'highContrast';

export const readStoredThemeMode = (): ThemeMode => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (isThemeMode(stored)) return stored;
  return localStorage.getItem(LEGACY_HIGH_CONTRAST_KEY) === 'true' ? 'highContrast' : 'default';
};

interface UiPreferencesStore {
  themeMode: ThemeMode;
  setThemeMode: (value: ThemeMode) => void;
}

export const useUiPreferencesStore = create<UiPreferencesStore>((set) => ({
  themeMode: readStoredThemeMode(),
  setThemeMode: (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    set({ themeMode: value });
  },
}));
